<template>
  <div class="container-fluid">
    <template v-if="status === 201">
      <faqs :section-id="sectionId"></faqs>
      <el-button @click="$router.push('/faq-sections')">OK</el-button>
    </template>
    <template v-else>
    <div v-for="attribute in errors" class="alert alert-danger" :key="attribute.field">
      {{attribute.value}}
    </div>
      <h4 class="m-3">Добавление раздела FAQ</h4>
      <el-form
        ref="form"
        :model="form"
        label-width="120px"
        id="uploadForm"
        name="uploadForm"
        enctype="multipart/form-data"
      >
        <el-form-item label="Название">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="Сортировка">
          <el-input v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item label="Активность">
          <el-checkbox v-model="form.activity"></el-checkbox>
        </el-form-item>

      <el-form-item label="Иконка">
        
        <el-row>
          <el-col :span="12">
            <el-select   
            v-model="form.icon"             
            placeholder="Выберите иконку"
            :style="{width: '100%', maxWidht: '100%'}"
            >
              <el-option
              v-for="it in getIcons"
              :key="it.id"
              :value="it.id"
              :label="it.alt || it.id"    
              >
              <el-row>
                <el-col :span="3"><el-image style="width: 34px; height: 34px" :src="it.path" fit="cover" /></el-col>
                <el-col :span="4"><span>{{it.alt || it.id}}</span></el-col>
              </el-row>                    
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button @click="$store.commit('iconDialog',true)">Добавить иконку</el-button>
          </el-col>
        </el-row>
       
      </el-form-item>
        <el-form-item class="m-3">
          <el-button type="primary" @click="(e) => storeSection(e)"
            >Создать</el-button
          >
          <el-button @click="back()">Отмена</el-button>
        </el-form-item>
      </el-form>
      <icon-dialog ></icon-dialog >
    </template>
  </div>
</template>

<script>
import axios from "axios";
import Faqs from "@/components/Faq/Faqs";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import getErrors from '../../composable/utils/getErrors';
import IconDialog from '@/components/Icon/AddIconDialog';

export default {
  components: {
    Faqs,
    IconDialog,
  },
  data: function () {
    return {
      form: {
        title: "",
        slug: "",
        icon: "",
        sort: 1,
        activity: true,
      },
      errors: [],
      status: 0,
      sectionId: 0,
    };
  },
  computed: {
    getIcons() {
        return this.$store.state.IconDialog.generalIcons
    },
  },

  methods: {
    back() {
      this.$router.push("/faq-sections");
    },
    getIcon(item) {
      let index = this.icons.indexOf(item);
      return this.icons[index].path;
    },
    storeSection(e) {
      const t = e.target;
      const data = new FormData();

      data.append("title", this.form.title);
      data.append("sort", this.form.sort);
      data.append("activity", this.form.activity);
      data.append("icon_id", this.form.icon)

      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      t.style.pointerEvents = "none";

      axios
        .post("faq/section/", data)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          this.sectionId = response.data.id
          this.status = response.status;          

          t.style.pointerEvents = "all";
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
          if (errors.response.status === 422) {
            this.errors = getErrors(errors.response.data.errors);
          }          

          t.style.pointerEvents = "all";
        });
    },
  },
};
</script>

<style scoped>
</style>